import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { StytchB2BProvider } from '@stytch/react/b2b'
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b'
import { initSentry } from './lib/sentry'
import { initAnalytics } from './lib/analytics'
import { setupApiInterceptor } from './lib/api-client'
import App from './App.tsx'
import './index.css'

// Initialize Sentry
initSentry()

// Initialize Google Analytics
initAnalytics()

// Setup API interceptor for 401 handling
setupApiInterceptor()

if (import.meta.env.MODE === 'dev' || import.meta.env.DEV) {
    console.log('import.meta.env', import.meta.env)
}

const stytch = new StytchB2BUIClient(import.meta.env.STYTCH_PUBLIC_TOKEN || '')

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <StytchB2BProvider stytch={stytch}>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <App />
            </BrowserRouter>
        </StytchB2BProvider>
    </React.StrictMode>,
)
